module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Project type")]), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.condoId) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.$route.params.type))]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.type_id),
      expression: "project.type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "required"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.projectTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.name))])
  }))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Project name")]), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.condoId) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.project.name))]) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.projectNames,
      "component-item": _vm.va_template,
      "get-label": _vm.getProjectName,
      "auto-select-one-item": false,
      "input-class": "form-control"
    },
    on: {
      "change": _vm.updateProjectNames
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Price")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.price),
      expression: "project.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter price",
      "required": "required"
    },
    domProps: {
      "value": (_vm.project.price)
    },
    on: {
      "blur": function($event) {
        _vm.project.price = _vm.formatNumber(_vm.project.price)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "price", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Size")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.size),
      expression: "project.size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter condo size",
      "required": "required"
    },
    domProps: {
      "value": (_vm.project.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "size", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Floor")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.floor),
      expression: "project.floor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter floor",
      "required": "required"
    },
    domProps: {
      "value": (_vm.project.floor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "floor", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tower")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.tower),
      expression: "project.tower"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter tower"
    },
    domProps: {
      "value": (_vm.project.tower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "tower", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Ex. ตึก B, ทิศ xxxx, วิวสระ")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Studio")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.studio),
      expression: "project.studio"
    }],
    staticClass: "nomargin",
    attrs: {
      "type": "checkbox",
      "id": "checkbox_studio",
      "true-value": '1',
      "false-value": '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.project.studio) ? _vm._i(_vm.project.studio, null) > -1 : _vm._q(_vm.project.studio, '1')
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.studio,
          $$el = $event.target,
          $$c = $$el.checked ? ('1') : ('0');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.studio = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.studio = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "studio", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "checkbox_studio"
    }
  }, [_vm._v("(If enable bedroom and bathroom has each one.)")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.studio == '0'),
      expression: "project.studio == '0'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Bedroom")]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.bedroom),
      expression: "project.bedroom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter number bedroom"
    },
    domProps: {
      "value": (_vm.project.bedroom)
    },
    on: {
      "blur": function($event) {
        _vm.project.bedroom = _vm.deformatNumber(_vm.project.bedroom)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "bedroom", $event.target.value)
      }
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.studio == '0'),
      expression: "project.studio == '0'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Bathroom")]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.bathroom),
      expression: "project.bathroom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter number bathroom"
    },
    domProps: {
      "value": (_vm.project.bathroom)
    },
    on: {
      "blur": function($event) {
        _vm.project.bathroom = _vm.deformatNumber(_vm.project.bathroom)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "bathroom", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Furnishing")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.furnishing),
      expression: "project.furnishing"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter furnishing"
    },
    domProps: {
      "value": (_vm.project.furnishing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "furnishing", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Electric")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.electric),
      expression: "project.electric"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter electric"
    },
    domProps: {
      "value": (_vm.project.electric)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "electric", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Remark")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.remark),
      expression: "project.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter remark",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.project.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "remark", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Ex. ใกล้ bts xx")])])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Location")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "map-container"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.gmapOptions.center,
      "zoom": _vm.gmapOptions.zoom,
      "options": _vm.gmapOptions.options
    }
  }, [(_vm.marker.enabled) ? _c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.marker.position.lat,
        lng: _vm.marker.position.lng
      }
    }
  }) : _vm._e()], 1)], 1)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Place")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.project.location ? _vm.project.location : 'No place'))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _c('div', {
    staticClass: "col-sm-5 col-xs-6"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("Latitude: " + _vm._s(_vm.project.latitude ? _vm.project.latitude : '-'))])]), _c('div', {
    staticClass: "col-sm-5 col-xs-6"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("Longitude: " + _vm._s(_vm.project.longitude ? _vm.project.longitude : '-'))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Owner name")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.owner),
      expression: "project.owner"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter owner name",
      "required": "required"
    },
    domProps: {
      "value": (_vm.project.owner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "owner", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Phone")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.phone),
      expression: "project.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "Enter phone",
      "required": "required"
    },
    domProps: {
      "value": (_vm.project.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "phone", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Line ID")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.line),
      expression: "project.line"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter line"
    },
    domProps: {
      "value": (_vm.project.line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "line", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Note")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.note),
      expression: "project.note"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter note",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.project.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "note", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Pin to top")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.pintop),
      expression: "project.pintop"
    }],
    staticClass: "nomargin",
    attrs: {
      "type": "checkbox",
      "id": "checkbox_top",
      "true-value": '1',
      "false-value": '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.project.pintop) ? _vm._i(_vm.project.pintop, null) > -1 : _vm._q(_vm.project.pintop, '1')
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.pintop,
          $$el = $event.target,
          $$c = $$el.checked ? ('1') : ('0');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.pintop = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.pintop = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "pintop", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "checkbox_top"
    }
  }, [_vm._v("(Move this project to top of table.)")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Photos")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('upload', {
    staticClass: "btn btn-outline btn-white",
    attrs: {
      "url": (_vm.baseUrl + "s3/upload/processs3.php"),
      "crop": false,
      "multiple": true
    },
    on: {
      "imageuploaded": _vm.addPic,
      "imageuploading": _vm.upload
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" " + _vm._s(_vm.uploading ? 'Uploading...' : 'Upload Image'))]), _c('ul', {
    staticClass: "photos"
  }, _vm._l((_vm.project.pictures), function(pic, index) {
    return _c('li', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (pic.path),
        expression: "pic.path"
      }]
    }), _c('div', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deletePic(index)
        }
      }
    }, [_c('i', {
      staticClass: "text-warning fa fa-times fa-2x"
    })])])
  }))], 1)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.uploading
    }
  }, [(_vm.condoId) ? _c('span', [_vm._v("Save change")]) : _c('span', [_vm._v("Create project")])]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])])])])]), (_vm.$ls.get('user').role_name == 'Super Admin' || _vm.$ls.get('user').role_name == 'Admin' || _vm.$ls.get('user').role_name == 'Operator') ? _c('div', {
    staticClass: "ibox-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.project.seller_name) ? _c('span', [_vm._v("Sale: " + _vm._s(_vm.project.seller_name))]) : _vm._e(), _c('span', [_vm._v("Admin: " + _vm._s(_vm.project.create_by ? _vm.project.create_by : '-') + " " + _vm._s(_vm.formatDate2(_vm.project.create_date)))])])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc613e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/condo/_type/_id/edit.vue
// module id = 418
// module chunks = 3